import Image from 'next/image';
import type { CoachingCtaSectionData } from '@/lib/coaching-cta';

interface CoachingCtaCardsProps {
  section: CoachingCtaSectionData;
}

const CARD_ICONS = {
  challenge: '/images/coaching-report/challenge.svg',
  academy: '/images/coaching-report/academy.svg',
} as const;

export function CoachingCtaCards({ section }: CoachingCtaCardsProps) {
  return (
    <section
      data-testid="coaching-cta-section"
      className="not-prose my-4 border-b border-white/[0.16] pb-4">
      <h3 className="mb-4 text-sm font-semibold leading-4 text-white">{section.title}</h3>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {section.cards.map((card) => (
          <article
            key={`${card.kind}-${card.href}`}
            data-coaching-cta-card={card.kind}
            className={`rounded-xl p-px ${card.description ? 'min-h-[162px]' : 'min-h-[132px]'}`}
            style={{
              backgroundImage:
                'linear-gradient(174deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(175deg, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0.10) 100%)',
            }}>
            <div
              className="flex h-full flex-col gap-4 rounded-[11px] p-4"
              style={{
                backgroundColor: '#070400',
                backgroundImage:
                  'linear-gradient(129deg, rgba(7, 4, 0, 0) 7%, rgba(249, 135, 21, 0.20) 100%), linear-gradient(136deg, rgba(249, 135, 21, 0.40) 0%, rgba(7, 4, 0, 0) 87%)',
              }}>
              <div className="flex flex-1 flex-col gap-2">
                <div className="flex items-center gap-2">
                  <Image
                    src={CARD_ICONS[card.kind]}
                    alt=""
                    width={28}
                    height={28}
                    className="size-7 shrink-0"
                    aria-hidden="true"
                  />
                  <h4 className="text-xs font-semibold leading-[14px] tracking-[0.02em] text-white">{card.title}</h4>
                </div>
                {card.description && <p className="m-0 text-xs leading-[14px] tracking-[-0.01em] text-[#CCCCCC]">{card.description}</p>}
              </div>

              <a
                href={card.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-fit items-center gap-1 rounded-lg bg-[#F98715] px-4 py-2.5 text-xs font-normal leading-[14px] tracking-[-0.01em] text-white no-underline transition-colors hover:bg-[#ff962e] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F98715]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-[#070400]">
                <span>{card.label}</span>
                <Image
                  src="/images/coaching-report/arrow-up-right.svg"
                  alt=""
                  width={14}
                  height={14}
                  className="size-3.5 shrink-0"
                  aria-hidden="true"
                />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
